import { HamletOrderableItem } from './orderable-item';
import { HamletPricingTier } from './pricing-tier';

export type HamletProduct = {
  readonly productDescription: string;
  readonly productKey: string;
  readonly productType: HamletProductType;
  readonly parentDescription: string;
  readonly parentKey: string;
  readonly userCountEnforced: boolean;
  readonly discountOptOut: boolean;
  readonly lastModified: string;
  readonly contactSalesForAdditionalPricing: boolean;

  readonly orderableItems: readonly HamletOrderableItem[];
  readonly monthly: readonly HamletPricingTier[];
  readonly annual: readonly HamletPricingTier[];

  readonly billingType: string;
  readonly dataCenter: boolean;
  readonly marketplaceAddon: boolean;
};

export type HamletProductType =
  | 'PERPETUAL'
  | 'ADDON'
  | 'HOSTED'
  | 'HOSTED_ADDON';
